import { doc, getDoc, setDoc } from '@battleops/localstore';
import { carryOutcomes, shiftWeek, makeOutcome, weekKey, localToday } from '@battleops/shared';
import { db } from './store';

// Week plans live at weekPlans/{YYYY-Www}. These helpers write whole outcome lists (small docs).

export async function readWeek(key) {
  const snap = await getDoc(doc(db, 'weekPlans', key));
  return snap.exists() ? snap.data() : null;
}

async function writeWeek(key, cur, outcomes, extra = {}) {
  const now = Date.now();
  await setDoc(doc(db, 'weekPlans', key), { id: key, note: '', ...(cur || {}), ...extra, outcomes, createdAt: cur?.createdAt || now, updatedAt: now });
}

/** Carry last week's unfinished outcomes into `key` (once). Only for the current week or later. */
export async function ensureWeekRolled(key) {
  if (key < weekKey(localToday())) return;
  const prevKey = shiftWeek(key, -1);
  const [prev, cur] = await Promise.all([readWeek(prevKey), readWeek(key)]);
  const next = carryOutcomes(prev, cur, prevKey);
  if (next) await writeWeek(key, cur, next);
}

export async function upsertOutcome(key, fields) {
  const cur = await readWeek(key);
  const list = cur?.outcomes || [];
  const i = list.findIndex((o) => o.id === fields.id);
  const next = i >= 0 ? list.map((o, j) => (j === i ? { ...o, ...fields } : o)) : [...list, makeOutcome(fields)];
  await writeWeek(key, cur, next);
}

export async function removeOutcome(key, id) {
  const cur = await readWeek(key);
  await writeWeek(key, cur, (cur?.outcomes || []).filter((o) => o.id !== id));
}

export async function setOutcomeDone(key, id, done) {
  await upsertOutcome(key, { id, done, doneAt: done ? Date.now() : null });
}
